exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".job_item[data-v-39603e9e]{cursor:pointer;margin-top:6px;padding:8px;border:1px solid #ebedf0;border-radius:3px;background:#fff;line-height:24px}", ""]);

// exports
